import { closeAppIssueReportDrawer } from '@/redux/actions/uiActions/drawerActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import selectors from '@/redux/selectors/selectors';
import { useSelector } from 'react-redux';
import ScrollContainerV2 from './v2/ScrollContainerV2';
import SliderHeader from './arguments/argumentOptionsSlider/SliderHeader';
import AppEditorIssueListRow from './AppEditorIssueListRow';
import DividerV2 from './v2/DividerV2';
import Panel from './panel/Panel';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';

const AppEditorIssueReportDrawer = () => {
  const appId = useArgSelector(selectors.param, 'appId');
  const appIssues = useSelector(memoizeSelector(`issuesByAppId-${appId}`, (state) => selectors.issuesByAppId(state, appId)));
  const drawerState = useSelector(memoizeSelector('appIssueReportDrawer', (state) => state.ui.appIssueReportDrawer)) || {};
  const handledIssues = appIssues?.filter((issue) => issue?.handledOn);
  const unhandledIssues = appIssues?.filter((issue) => !issue?.handledOn);
  const open = drawerState?.open;

  return (
    <div className={`comp-argument-option-slider app-output-drawer ${open ? 'open' : ''}`}>
      <div className={'backing'} onClick={closeAppIssueReportDrawer} />
      <div className={'content'}>
        <SliderHeader title="Reported Issues" onClose={closeAppIssueReportDrawer} />
        <Panel.Section title="Unhandled Issues" collapsable={true}>
          {!!unhandledIssues?.length && (
            <div className={'slider-content'}>
              <ScrollContainerV2 className="issue-list">
                {unhandledIssues?.map((issue, i) => (
                  <AppEditorIssueListRow key={issue?.id || i} issue={issue} />
                ))}
              </ScrollContainerV2>
            </div>
          )}
        </Panel.Section>
        <Panel.Section title="Handled Issues" collapsable={true} collapseByDefault>
          <DividerV2 style={{ margin: '0px 10px' }} />
          {!!handledIssues?.length && (
            <div className={'slider-content'}>
              <ScrollContainerV2 className="issue-list">
                {handledIssues?.map((issue, i) => (
                  <AppEditorIssueListRow key={issue?.id || i} issue={issue} />
                ))}
              </ScrollContainerV2>
            </div>
          )}
        </Panel.Section>
      </div>
    </div>
  );
};

export default AppEditorIssueReportDrawer;
